import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

const contains = (intl, messageId) => intl && !!intl.messages[messageId];

const Footer = ({ intl, className }) => <footer className={ `footer ${ className != null ? className : '' }` }>
  <div className="container p-0">
    <div className="row">
      <div className="col">
        <div className="text-center footer-links">
          <ul>
            { contains(intl, 'footerPage.privacy') && <li><a href="/links/privacy" target="_blank" title="Privacy &amp; GDPR, opens in new window">Privacy &amp; GDPR</a></li> }
            { contains(intl, 'footerPage.cookies') && <li><a href="/links/cookies" target="_blank" title="Cookies, opens in new window">Cookies</a></li> }
            { contains(intl, 'footerPage.termsOfUse') && <li><a href="/links/termsOfUse" target="_blank" title="Terms of Use, opens in new window">Terms Of Use</a></li> }
          </ul>
        </div>
        <div id="copyright" className="text-center">&copy; { (new Date()).getFullYear() } TAINA Technology Limited. All Rights Reserved.</div>
      </div>
    </div>
  </div>
</footer>;

Footer.propTypes = {
  intl: PropTypes.shape({
    messages: PropTypes.any
  }).isRequired,
  className: PropTypes.string
};

Footer.defaultProps = {
  className: null
};

export default injectIntl(Footer);
